<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/unidadeMedida" > Cadastro/Produtos e Serviços/Unidades de Medidas </router-link>
      <label class="labelBar">/</label>
      <label v-if="!readOnly"> Editar</label>
      <label v-else> Ver</label>
    </div>
    <tab-navegacao-produto />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col col="6">
            <v-text-field
              label="Unidade de medida *"
              v-model="abreviatura"
              v-uppercase
              :counter="3"
              maxlength="3"
              :readonly="readOnly"
              :rules="[
                (v) => !!v || 'A Unidade de Medida é obrigatória'
              ]"
              required
            ></v-text-field>
          </v-col>
          <v-col col="6">
            <v-text-field
              label="Descrição *"
              v-model="descricao"
              v-uppercase
              :counter="200"
              :readonly="readOnly"
              :rules="[(v) => !!v || 'A Descrição é obrigatória']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col cols="12" sm="6">
          <v-checkbox :readonly="readOnly" v-model="unidadeMedida.ativo" @click.native.stop.prevent="checkAssociacao()" label="Ativo"></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6" class="text-right">
          <v-btn to="/unidadeMedida" color="error" class="mr-4" v-if="!readOnly">
            Voltar
          </v-btn>
          <v-btn to="/unidadeMedida" color="success" class="mr-4" v-else>
            Voltar
          </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4" v-if="!readOnly">
            Salvar
          </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import { editarUnidadeMedidaAsync } from "../../../services/unidadeMedidaService";
import TabNavegacaoProduto from "../../Tabs/TabCadastroProduto";
import { mapState, mapActions } from "vuex";
import { getUserPermission } from "@/services/loginService";

export default {
  name: "editarUnidadeMedida",
  data: () => ({
    overlay: false,
    valid: true,
    abreviatura: null,
    descricao: null,
    readOnly: false,
  }),
  computed: {
    ...mapState("unidadeMedida", ["unidadeMedida"]),
    ...mapState("produto", ["produtos"]),
  },
  methods: {
    ...mapActions("produto", ["atualizarProdutos"]),
    ...mapActions("unidadeMedida", ["updateUnidadeMedida"]),
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await editarUnidadeMedidaAsync(
          this.unidadeMedida.id,
          this.abreviatura,
          this.descricao,
          this.unidadeMedida.ativo
        );
        if (!resposta || resposta.message || resposta.Message) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          this.$alert(resposta && (resposta.message || resposta.Message) ? resposta.message || resposta.Message : "", "Desculpe, falha na operação!", "error");
        } else {
          this.updateUnidadeMedida(resposta);
          this.overlay = false;
          this.$store.dispatch("ui/showSnackbar", {
            text: "Atualizado com sucesso!",
            color: "success",
            timeout: 3000,
          });
          this.$router.push("/unidadeMedida");
        }
      }
    },
    findProduto(undMedId) {
      return this.produtos.filter((p) => {
        return p.idUnidadeMedida == undMedId && p.ativo === true;
      });
    },
    checkAssociacao: async function () {
      if (!this.unidadeMedida.ativo) {
        if (!this.produtos || this.produtos.length == 0) {
          this.overlay = true;
          await this.atualizarProdutos();
          this.overlay = false;
        }
        var produtos = this.findProduto(this.unidadeMedida.id);
        if (produtos != null && produtos.length > 0) {
          this.$alert(
            "O(s) produtos(s) '" +
              produtos.map((e) => e.descricao).join("', '") +
              "' estão ativos e associados a essa Unidade de Medida.",
            "Ação não permitida!",
            "error"
          );
          this.unidadeMedida.ativo = !this.unidadeMedida.ativo;
        }
      }
    }
  },
  created: function () {
    this.readOnly = !getUserPermission(6);
    this.abreviatura = this.unidadeMedida.abreviatura;
    this.descricao = this.unidadeMedida.descricao;
  },
  components: {
    TabNavegacaoProduto,
  },
};
</script>
